/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToMutation } from '../../mutators/add-meta';
import { addMetaToQuery } from '../../mutators/add-meta';
import type {
  Error,
  ExecuteCliRequest,
  ExecuteCliResponse,
  ExecuteWPCLIRequest,
  SiteID,
  WordpressLoginResponse,
  WordpressStatusResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Deprecated. Runs a WordPress command using separate command, action, value, and params fields. Use POST /sites/{id}/wpcli instead, which accepts a single command string.
 * @summary [Deprecated] Run a WordPress CLI command
 */
export const callSiteCliDeprecated = (
  id: SiteID,
  executeCliRequest: ExecuteCliRequest,
  signal?: AbortSignal
) => {
  return customFetch<ExecuteCliResponse>({
    url: `/v1/sites/${id}/cli`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: executeCliRequest,
    signal,
  });
};

export const getCallSiteCliDeprecatedMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof callSiteCliDeprecated>>,
    TError,
    { id: SiteID; data: ExecuteCliRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof callSiteCliDeprecated>>,
  TError,
  { id: SiteID; data: ExecuteCliRequest },
  TContext
> => {
  const mutationKey = ['callSiteCliDeprecated'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof callSiteCliDeprecated>>,
    { id: SiteID; data: ExecuteCliRequest }
  > = props => {
    const { id, data } = props ?? {};

    return callSiteCliDeprecated(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/cli` },
    {
      operationId: 'app.controllers.wordpress_controller.call_site_cli_deprecated',
      operationName: 'callSiteCliDeprecated',
    }
  );

  return customOptions;
};

export type CallSiteCliDeprecatedMutationResult = NonNullable<
  Awaited<ReturnType<typeof callSiteCliDeprecated>>
>;
export type CallSiteCliDeprecatedMutationBody = ExecuteCliRequest;
export type CallSiteCliDeprecatedMutationError = Error;

/**
 * @summary [Deprecated] Run a WordPress CLI command
 */
export const useCallSiteCliDeprecated = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof callSiteCliDeprecated>>,
      TError,
      { id: SiteID; data: ExecuteCliRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof callSiteCliDeprecated>>,
  TError,
  { id: SiteID; data: ExecuteCliRequest },
  TContext
> => {
  const mutationOptions = getCallSiteCliDeprecatedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns a short-lived sign-in URL that logs you into the WordPress admin dashboard for this site. WordPress sites only.
 * @summary Get a one-click WordPress admin login link
 */
export const generateSiteWpLoginLink = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<WordpressLoginResponse>({
    url: `/v1/sites/${id}/wp/login`,
    method: 'GET',
    signal,
  });
};

export const getGenerateSiteWpLoginLinkQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/wp/login`] as const;
};

export const getGenerateSiteWpLoginLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGenerateSiteWpLoginLinkQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof generateSiteWpLoginLink>>> = ({
    signal,
  }) => generateSiteWpLoginLink(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/wp/login`,
      operationId: 'app.controllers.wordpress_controller.generate_site_wp_login_link',
      operationName: 'generateSiteWpLoginLink',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GenerateSiteWpLoginLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateSiteWpLoginLink>>
>;
export type GenerateSiteWpLoginLinkQueryError = Error;

export function useGenerateSiteWpLoginLink<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
          TError,
          Awaited<ReturnType<typeof generateSiteWpLoginLink>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSiteWpLoginLink<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
          TError,
          Awaited<ReturnType<typeof generateSiteWpLoginLink>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSiteWpLoginLink<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a one-click WordPress admin login link
 */

export function useGenerateSiteWpLoginLink<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGenerateSiteWpLoginLinkQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGenerateSiteWpLoginLinkSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGenerateSiteWpLoginLinkQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof generateSiteWpLoginLink>>> = ({
    signal,
  }) => generateSiteWpLoginLink(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/wp/login`,
      operationId: 'app.controllers.wordpress_controller.generate_site_wp_login_link',
      operationName: 'generateSiteWpLoginLink',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GenerateSiteWpLoginLinkSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateSiteWpLoginLink>>
>;
export type GenerateSiteWpLoginLinkSuspenseQueryError = Error;

export function useGenerateSiteWpLoginLinkSuspense<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSiteWpLoginLinkSuspense<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSiteWpLoginLinkSuspense<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a one-click WordPress admin login link
 */

export function useGenerateSiteWpLoginLinkSuspense<
  TData = Awaited<ReturnType<typeof generateSiteWpLoginLink>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSiteWpLoginLink>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGenerateSiteWpLoginLinkSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reports whether WordPress is running normally or has critical errors. Non-WordPress sites return not_applicable.
 * @summary Get WordPress health status
 */
export const findSiteWpStatus = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<WordpressStatusResponse>({
    url: `/v1/sites/${id}/wp/status`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteWpStatusQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/wp/status`] as const;
};

export const getFindSiteWpStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteWpStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteWpStatus>>> = ({ signal }) =>
    findSiteWpStatus(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/wp/status`,
      operationId: 'app.controllers.wordpress_controller.find_site_wp_status',
      operationName: 'findSiteWpStatus',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteWpStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteWpStatusQueryResult = NonNullable<Awaited<ReturnType<typeof findSiteWpStatus>>>;
export type FindSiteWpStatusQueryError = Error;

export function useFindSiteWpStatus<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteWpStatus>>,
          TError,
          Awaited<ReturnType<typeof findSiteWpStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteWpStatus<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteWpStatus>>,
          TError,
          Awaited<ReturnType<typeof findSiteWpStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteWpStatus<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get WordPress health status
 */

export function useFindSiteWpStatus<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteWpStatusQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteWpStatusSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteWpStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteWpStatus>>> = ({ signal }) =>
    findSiteWpStatus(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/wp/status`,
      operationId: 'app.controllers.wordpress_controller.find_site_wp_status',
      operationName: 'findSiteWpStatus',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteWpStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteWpStatusSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteWpStatus>>
>;
export type FindSiteWpStatusSuspenseQueryError = Error;

export function useFindSiteWpStatusSuspense<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteWpStatusSuspense<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteWpStatusSuspense<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get WordPress health status
 */

export function useFindSiteWpStatusSuspense<
  TData = Awaited<ReturnType<typeof findSiteWpStatus>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteWpStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteWpStatusSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Runs a WordPress CLI command on the site. Pass the full command in the command field (for example, user list --format=json). Returns command output.
 * @summary Run a WordPress CLI command
 */
export const callSiteWpcli = (
  id: SiteID,
  executeWPCLIRequest: ExecuteWPCLIRequest,
  signal?: AbortSignal
) => {
  return customFetch<ExecuteCliResponse>({
    url: `/v1/sites/${id}/wpcli`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: executeWPCLIRequest,
    signal,
  });
};

export const getCallSiteWpcliMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof callSiteWpcli>>,
    TError,
    { id: SiteID; data: ExecuteWPCLIRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof callSiteWpcli>>,
  TError,
  { id: SiteID; data: ExecuteWPCLIRequest },
  TContext
> => {
  const mutationKey = ['callSiteWpcli'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof callSiteWpcli>>,
    { id: SiteID; data: ExecuteWPCLIRequest }
  > = props => {
    const { id, data } = props ?? {};

    return callSiteWpcli(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/wpcli` },
    {
      operationId: 'app.controllers.wordpress_controller.call_site_wpcli',
      operationName: 'callSiteWpcli',
    }
  );

  return customOptions;
};

export type CallSiteWpcliMutationResult = NonNullable<Awaited<ReturnType<typeof callSiteWpcli>>>;
export type CallSiteWpcliMutationBody = ExecuteWPCLIRequest;
export type CallSiteWpcliMutationError = Error;

/**
 * @summary Run a WordPress CLI command
 */
export const useCallSiteWpcli = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof callSiteWpcli>>,
      TError,
      { id: SiteID; data: ExecuteWPCLIRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof callSiteWpcli>>,
  TError,
  { id: SiteID; data: ExecuteWPCLIRequest },
  TContext
> => {
  const mutationOptions = getCallSiteWpcliMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
